import { render, staticRenderFns } from "./MfaLayout.vue?vue&type=template&id=5652aa39&scoped=true"
import script from "./MfaLayout.vue?vue&type=script&lang=js"
export * from "./MfaLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5652aa39",
  null
  
)

export default component.exports